import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { api } from '../client';
import { expectStatus } from '@/lib/result';

export const AGENT_KEY = ['agent', 'settings'] as const;

type Loaded = Extract<Awaited<ReturnType<typeof api.agent.settings>>, { status: 200 }>['body'];

/** The settings and the choices this deployment offers (models, languages, tones). */
export function useAgentSettings(): UseQueryResult<Loaded> {
  return useQuery({
    queryKey: AGENT_KEY,
    queryFn: async () => expectStatus(await api.agent.settings(), 200),
  });
}

export type AgentSettingsResponse = Loaded;
